 <template>
  <div class="payoff-date">
    <div class="title">MORTGAGE PAYOFF DATE</div>
    <div class="date">{{PAYOFF_DATE}}</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import { GETTERS } from "../storeConstants";

const { PAYOFF_DATE } = GETTERS;

export default {
  computed: {
    ...mapGetters([PAYOFF_DATE])
  }
};
</script>
<style scoped lang="scss">
@mixin gradient-text($start-color, $end-color, $fallback: #000) {
  color: $fallback;
  @supports (background-clip: text) {
    color: transparent;
    background-image: linear-gradient(to right, $start-color, $end-color),
      linear-gradient(to bottom, #fff, #fff);
    -webkit-background-clip: text;
    background-clip: text;
  }
}
.payoff-date {
  height: 152px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f3f3f3;
  > * {
    position: relative;
    display: flex;
    justify-content: center;
  }
  @media (min-width: 768px) {
    margin-bottom: 0;
  }
}
.title {
  font-family: Poppins;
  font-size: 14px;
  line-height: 1;
  letter-spacing: -0.35px;
  color: #808080;
  margin-bottom: 10px;
}
.date {
  text-transform: uppercase;
  font-family: Poppins;
  font-size: 36px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  @include gradient-text(#60c5b7, #acd14c);
  line-height: 1;
}
</style>